import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketSurfaces } from '../../shared/ticket/ticketSurfaces.styles'
import { ticketColors } from '../../shared/theme/ticketColors';

export const styles = StyleSheet.create({
  container: {
    ...ticketSurfaces.screen,
  },
  containerWide: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.lg,
  },
  containerCompact: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.md,
  },
  kpiSheet: {
    gap: spacing.xs,
  },
  kpiSheetTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontSize: 15,
    fontWeight: '800',
  },
  kpiSheetHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontSize: 12,
    marginBottom: spacing.xs,
  },
  /** Cabecera fija: pestañas (alineado a hero cards: padding y radio suave). */
  reportsSectionToggleWrap: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.md,
    backgroundColor: ticketColors.bg,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  content: {
    gap: spacing.lg,
    paddingBottom: spacing.xxl,
  },
  emptyStateCard: {
    ...ticketSurfaces.paperSheet,
    padding: spacing.lg,
    gap: spacing.sm,
  },
  emptyStateText: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  errorCard: {
    backgroundColor: ticketColors.paper,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.bad,
    padding: spacing.lg,
    gap: spacing.md,
  },
  errorText: {
    ...typography.body,
    color: ticketColors.bad,
    fontWeight: '600',
  },
  /** Loader inline (secciones); no usar en pantalla completa — ahí va ShellScreenLoading. */
  loadingWrap: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: spacing.lg,
  },
  /** Ventas: fila al cambiar período (KPIs se recargan; los números debajo pueden ser del período anterior). */
  ventasPeriodUpdatingRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    marginTop: spacing.sm,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    backgroundColor: ticketColors.paper,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  ventasPeriodUpdatingText: {
    ...typography.caption,
    color: ticketColors.ink2,
    flex: 1,
  },
  ventasStaleData: {
    opacity: 0.52,
  },
  title: {
    ...typography.titleXL,
    color: ticketColors.ink,
    marginBottom: spacing.xs,
  },
  subtitle: {
    ...typography.body,
    color: ticketColors.ink2,
    marginBottom: spacing.sm,
  },
  card: {
    ...ticketSurfaces.paperSheet,
    padding: spacing.lg,
    gap: spacing.md,
  },
  cardTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
    marginBottom: spacing.xs,
    flexShrink: 1,
  },
  summaryGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  summaryHeader: {
    gap: spacing.xs,
  },
  summaryItem: {
    ...ticketSurfaces.paperSheet,
    flexGrow: 1,
    flexBasis: '47%',
    minWidth: 140,
    padding: spacing.md,
    gap: spacing.xs,
  },
  summaryItemLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  summaryItemValue: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  summaryItemCaption: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  sectionHeader: {
    gap: spacing.xs,
    marginTop: spacing.xs,
  },
  sectionTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
  },
  sectionSubtitle: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  advancedToggleRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  advancedToggleText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
  },
  cardBlock: {
    gap: spacing.xs,
  },
  metric: {
    ...typography.titleXL,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  caption: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 20,
  },
  captionBlock: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 20,
    marginBottom: spacing.xs,
  },
  captionStrong: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing.sm,
    minHeight: 24,
  },
  rowLabel: {
    ...typography.body,
    color: ticketColors.ink,
    flex: 1,
    minWidth: 0,
    marginRight: spacing.sm,
  },
  rowValue: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
    flexShrink: 0,
  },
  inputsBlock: {
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  input: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    color: ticketColors.ink,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
  },
  primaryButton: {
    backgroundColor: ticketColors.gold,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.lg,
  },
  primaryButtonText: {
    ...typography.body,
    color: ticketColors.goldInk,
    fontWeight: '700',
  },
  disabled: {
    opacity: 0.6,
  },
  policyRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  policyChip: {
    borderRadius: 999,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    backgroundColor: ticketColors.paper2,
  },
  policyChipSelected: {
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.brandSoft,
  },
  policyChipText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  policyChipTextSelected: {
    color: ticketColors.ink,
    fontWeight: '800',
  },
  policyChipDisabled: {
    opacity: 0.45,
  },
  policyChipTextMuted: {
    color: ticketColors.ink2,
  },
  modeToggleRow: {
    marginTop: spacing.md,
    marginBottom: spacing.sm,
  },
  /** Fondo explícito: en web el ScrollView tiene default blanco si no se setea `style`. */
  modeToggleScroll: {
    backgroundColor: ticketColors.bg,
  },
  modeToggleScrollContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: spacing.xs,
  },
  /** Pestañas principales: segmento iOS, no chip suelto (vs filtros de período/categoría). */
  reportsSectionSegment: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    backgroundColor: ticketColors.paper,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    padding: 3,
    gap: 3,
  },
  reportsSectionSegmentItem: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minWidth: 56,
    minHeight: 40,
    paddingVertical: 9,
    paddingHorizontal: 4,
    borderRadius: 7,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: 'transparent',
  },
  reportsSectionSegmentItemSelected: {
    backgroundColor: ticketColors.paper,
    borderColor: ticketColors.ruleSoft,
  },
  reportsSectionSegmentText: {
    ...typography.caption,
    fontSize: 12,
    lineHeight: 16,
    color: ticketColors.ink2,
    fontWeight: '600',
    textAlign: 'center',
  },
  reportsSectionSegmentTextSelected: {
    color: ticketColors.ink,
    fontWeight: '800',
  },
  /** Personal: bloques a ancho completo (sin max-width centrado). */
  personalFullWidthBlock: {
    alignSelf: 'stretch',
    width: '100%' as const,
    marginBottom: spacing.sm,
  },
  personalKpiShell: {
    marginTop: spacing.xs,
    marginBottom: spacing.sm,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
  },
  personalKpiGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    alignSelf: 'stretch',
    width: '100%' as const,
  },
  personalKpiGridWide: {
    flexWrap: 'nowrap',
  },
  /** Métrica plana Personal: 2×2 móvil, franja en escritorio. */
  reportsMetricTilePersonal: {
    flexGrow: 1,
    flexBasis: '47%',
    minWidth: 0,
    maxWidth: '48%',
    minHeight: 88,
    justifyContent: 'space-between',
  },
  reportsMetricTilePersonalWide: {
    flexBasis: 0,
    minWidth: 0,
    maxWidth: undefined,
    minHeight: 76,
  },
  personalKpiTileValue: {
    fontSize: 17,
    fontWeight: '800' as const,
    color: ticketColors.ink,
    letterSpacing: -0.3,
    lineHeight: 21,
    marginTop: 2,
  },
  personalKpiTileValueWide: {
    fontSize: 18,
    lineHeight: 22,
  },
  personalKpiTileSub: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontSize: 11,
    lineHeight: 15,
  },
  personalSignalsSection: {
    alignSelf: 'stretch',
    width: '100%' as const,
    marginBottom: spacing.md,
  },
  personalSignalsEmptyCopy: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 19,
  },
  personalSignalList: {
    alignSelf: 'stretch',
  },
  personalSignalListWide: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  personalSignalCardWide: {
    flexBasis: '48%',
    flexGrow: 1,
    minWidth: 280,
    maxWidth: undefined,
    marginBottom: 0,
  },
  personalSignalCardBody: {
    gap: 4,
    paddingVertical: spacing.sm,
  },
  personalSignalDetail: {
    ...typography.caption,
    fontSize: 13,
    lineHeight: 19,
    color: ticketColors.ink2,
    marginTop: 2,
  },
  personalSignalsFootnote: {
    ...typography.caption,
    fontSize: 12,
    lineHeight: 17,
    color: ticketColors.ink3,
    fontStyle: 'italic',
    marginTop: spacing.md,
  },
  /** Ranking operadores: filas compactas (no metrics box ancho completo). */
  personalRankingBlock: {
    alignSelf: 'stretch',
    width: '100%' as const,
    marginTop: spacing.lg,
    marginBottom: spacing.sm,
  },
  personalRankingHint: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontSize: 12,
    lineHeight: 17,
    marginBottom: spacing.sm,
  },
  personalRankingCardWrap: {
    marginBottom: spacing.sm,
  },
  personalRankingCardBody: {
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
    gap: spacing.xs,
  },
  personalRankingRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
  },
  personalRankingRowWide: {
    alignItems: 'center',
  },
  personalRankingTableHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    marginBottom: spacing.xs,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  personalRankingTableHeaderCell: {
    fontSize: 10,
    fontWeight: '700' as const,
    color: ticketColors.ink3,
    textTransform: 'uppercase' as const,
    letterSpacing: 0.2,
  },
  personalRankingTableColRank: {
    minWidth: 28,
    textAlign: 'center' as const,
  },
  personalRankingTableColName: {
    flex: 1,
    minWidth: 120,
  },
  personalRankingTableColStat: {
    minWidth: 56,
    textAlign: 'right' as const,
  },
  personalRankingTableColMoney: {
    minWidth: 72,
    textAlign: 'right' as const,
  },
  personalRankingTableColChevron: {
    width: 20,
  },
  personalRankingRankBadge: {
    minWidth: 28,
    height: 28,
    borderRadius: 8,
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 4,
    marginTop: 1,
  },
  personalRankingRankText: {
    color: ticketColors.ink,
    fontSize: 12,
    fontWeight: '800' as const,
    fontVariant: ['tabular-nums'],
  },
  personalRankingMain: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  personalRankingStats: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    flexShrink: 0,
    gap: spacing.md,
  },
  personalRankingStatsMobile: {
    marginTop: 2,
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    gap: spacing.lg,
  },
  personalRankingStatsIndented: {
    paddingLeft: 36,
  },
  personalRankingStat: {
    alignItems: 'flex-start',
    minWidth: 40,
  },
  personalRankingStatValue: {
    fontSize: 14,
    fontWeight: '700' as const,
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
    lineHeight: 18,
  },
  personalRankingStatLabel: {
    fontSize: 10,
    lineHeight: 13,
    color: ticketColors.ink3,
    marginTop: 1,
    textTransform: 'uppercase' as const,
    letterSpacing: 0.2,
  },
  personalRankingMoney: {
    fontSize: 15,
    fontWeight: '700' as const,
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
    lineHeight: 18,
    minWidth: 72,
    textAlign: 'right' as const,
    alignSelf: 'flex-end',
  },
  personalRankingChevron: {
    color: ticketColors.ink3,
    fontSize: 18,
    fontWeight: '600' as const,
    lineHeight: 20,
    marginTop: 2,
    paddingLeft: 2,
  },
  personalRankingPager: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: spacing.xs,
    gap: spacing.sm,
  },
  /** Encabezado de cada sub-pantalla: título de sección + acción a la derecha. */
  reportsViewHeaderRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.md,
    marginBottom: spacing.xs,
  },
  reportsViewHeaderTextCol: {
    flex: 1,
    minWidth: 0,
  },
  reportsSectionTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
  },
  reportsSectionSubtitle: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 20,
    marginTop: 2,
  },
  /** Regla horizontal entre grandes bloques (ej. Totales ↔ Análisis ↔ Detalle). */
  reportsVentasSectionDivider: {
    alignSelf: 'stretch',
    height: StyleSheet.hairlineWidth,
    marginVertical: spacing.lg,
    backgroundColor: ticketColors.rule,
    opacity: 0.95,
  },
  /** Panel único: período + ítems (Ventas y Personal). */
  reportsScopeFiltersPanel: {
    alignSelf: 'stretch',
    width: '100%',
  },
  reportsScopeFiltersCardBody: {
    gap: spacing.sm,
    paddingVertical: spacing.sm,
  },
  reportsScopeFiltersCardBodyMobile: {
    gap: spacing.xs,
    paddingVertical: spacing.xs,
  },
  reportsScopeFiltersBusyRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  reportsScopeFiltersBusyText: {
    fontSize: 13,
    color: ticketColors.ink3,
  },
  reportsScopeFiltersSectionDivider: {
    alignSelf: 'stretch',
    height: StyleSheet.hairlineWidth,
    marginVertical: spacing.xs,
    backgroundColor: ticketColors.rule,
    opacity: 0.9,
  },
  reportsScopeFiltersHint: {
    color: ticketColors.ink3,
    marginBottom: spacing.xs,
  },
  /** Bloque «Ítems del período»: rejilla de filtros + buscador a ancho completo. */
  ventasItemsPeriodBlock: {
    alignSelf: 'stretch',
    gap: spacing.xs,
    width: '100%',
  },
  ventasItemsPeriodBlockWide: {
    gap: spacing.md,
  },
  ventasItemsPeriodFiltersWrap: {
    alignSelf: 'stretch',
    width: '100%',
  },
  ventasItemsPeriodFiltersWrapWide: {
    gap: spacing.sm,
  },
  ventasItemsPeriodSearchWrap: {
    alignSelf: 'stretch',
    width: '100%',
    minWidth: 0,
  },
  ventasSearchBlock: {
    alignSelf: 'stretch',
    width: '100%',
    minWidth: 0,
  },
  ventasSearchSuggestionsPanel: {
    marginTop: spacing.xs,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
    maxHeight: 220,
    backgroundColor: ticketColors.paper,
  },
  ventasSearchSuggestionsScroll: {
    maxHeight: 216,
  },
  ventasPinnedProductChip: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    marginTop: spacing.xs,
    paddingVertical: spacing.xs + 2,
    paddingHorizontal: spacing.sm,
    borderRadius: 10,
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  ventasPinnedProductChipText: {
    flex: 1,
    minWidth: 0,
  },
  /** Botón catálogo junto al buscador unificado (misma altura que SCAN). */
  ventasCatalogPickerButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    flexShrink: 0,
    minHeight: 36,
    minWidth: 36,
    paddingVertical: 7,
    paddingHorizontal: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
  },
  ventasCatalogPickerButtonIconOnly: {
    width: 36,
    minWidth: 36,
    maxWidth: 36,
    height: 36,
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  ventasCatalogPickerButtonLabel: {
    ...typography.caption,
    fontWeight: '700',
    fontSize: 11,
    letterSpacing: 0.2,
    color: ticketColors.ink2,
  },
  ventasCatalogModalTitleRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    minWidth: 0,
    paddingRight: spacing.sm,
  },
  ventasCatalogModalTitleIcon: {
    width: 40,
    height: 40,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    flexShrink: 0,
  },
  ventasCatalogModalTitleTextBlock: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  ventasCatalogModalTitleMain: {
    ...typography.titleLg,
    fontSize: 17,
    lineHeight: 22,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  ventasCatalogModalTitleSub: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontSize: 12,
    lineHeight: 16,
  },
  /** Ventas: tablero tipo KPI de Stock (actualizado con el período seleccionado). */
  ventasIndicatorsShell: {
    ...ticketSurfaces.paperSheet,
    alignSelf: 'stretch',
    marginTop: spacing.sm,
    marginBottom: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.md,
    gap: spacing.sm,
  },
  ventasIndicatorsHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing.sm,
    flexWrap: 'wrap',
  },
  ventasIndicatorsHeaderTitle: {
    flex: 1,
    minWidth: 0,
    fontSize: 11,
    fontWeight: '800' as const,
    color: ticketColors.ink3,
    letterSpacing: 0.35,
    textTransform: 'uppercase' as const,
  },
  ventasIndicatorsHeaderHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
    fontSize: 12,
    flexShrink: 0,
  },
  /** Segunda sección dentro del mismo shell (ej. Desglose bajo KPIs): evita repetir fecha y segundo card. */
  ventasIndicatorsSubsection: {
    marginTop: spacing.xs,
    paddingTop: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    gap: spacing.sm,
    alignSelf: 'stretch',
  },
  ventasIndicatorsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  /** KPI tile boxed (proto `.kpi`): tile bg + hairline + radius 10. */
  reportsMetricTile: {
    flexGrow: 1,
    minWidth: '46%',
    gap: 4,
    backgroundColor: ticketColors.tile,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.rule,
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  /** Escritorio/tablet: ~3 columnas para 6 KPI fijos. */
  reportsMetricTileWide: {
    flex: 1,
    minWidth: '30%',
  },
  /** Cobros / comparación (N celdas variables): hasta 5 por fila en escritorio. */
  reportsMetricTileAdaptiveWide: {
    flex: 1,
    minWidth: '17%',
  },
  reportsMetricTileWarning: {
    backgroundColor: ticketColors.warnBg,
    borderColor: ticketColors.warnBorder,
  },
  ventasIndicatorLabel: {
    fontSize: 10,
    fontWeight: '800' as const,
    color: ticketColors.ink3,
    letterSpacing: 0.35,
    textTransform: 'uppercase' as const,
  },
  ventasIndicatorValue: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontWeight: '800',
    letterSpacing: -0.2,
  },
  ventasIndicatorValueEmphasis: {
    fontSize: 22,
    lineHeight: 28,
  },
  ventasIndicatorValueWarning: {
    color: ticketColors.warn,
  },
  ventasIndicatorValuePositive: {
    color: ticketColors.ok,
  },
  ventasIndicatorValueNegative: {
    color: ticketColors.bad,
  },
  ventasIndicatorSub: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
    fontSize: 12,
  },
  ventasIndicatorSubWarning: {
    color: ticketColors.warn,
    fontWeight: '700',
  },
  /** Desglose por medio de cobro: nombre legible (caso mixto). */
  ventasBreakdownMethodName: {
    ...typography.body,
    fontSize: 13,
    color: ticketColors.ink,
    fontWeight: '700',
    lineHeight: 18,
  },
  /** Encabezado de bloque (Cierre del período / Análisis). */
  reportsBlockHeading: {
    marginTop: spacing.lg,
    marginBottom: spacing.xs,
  },
  reportsBlockHeadingLabel: {
    fontSize: 11,
    fontWeight: '700' as const,
    color: ticketColors.ink3,
    letterSpacing: 0.5,
    textTransform: 'uppercase' as const,
  },
  reportsBlockHeadingDescription: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 19,
    marginTop: 4,
  },
  /**
   * Listados tipo “Ventas por producto”: borde lateral neutro + mismo lenguaje que cards Stock/Catálogo.
   */
  reportsDenseListCardWrap: {
    flexDirection: 'row',
    borderRadius: 14,
    overflow: 'hidden',
    marginBottom: spacing.sm,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  reportsDenseListCardAccent: {
    width: 3,
    backgroundColor: ticketColors.rule,
  },
  reportsDenseListCardBody: {
    flex: 1,
    minWidth: 0,
    paddingVertical: 10,
    paddingHorizontal: spacing.md,
    gap: spacing.sm,
  },
  reportsDenseListCardHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
    marginBottom: 10,
  },
  reportsDenseListRankBadge: {
    minWidth: 30,
    height: 30,
    borderRadius: 8,
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 6,
  },
  reportsDenseListRankText: {
    color: ticketColors.ink,
    fontSize: 13,
    fontWeight: '800',
    fontVariant: ['tabular-nums'],
  },
  reportsDenseListTitleBlock: {
    flex: 1,
    minWidth: 0,
  },
  reportsDenseListTitle: {
    color: ticketColors.ink,
    fontWeight: '600',
    fontSize: 14,
    lineHeight: 19,
  },
  reportsDenseListMeta: {
    marginTop: 2,
    color: ticketColors.ink3,
    fontSize: 11,
    lineHeight: 14,
    letterSpacing: 0.2,
  },
  reportsDenseListDetalleBtn: {
    marginTop: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
  },
  reportsDenseListDetalleBtnText: {
    color: ticketColors.gold,
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 0.2,
  },
  reportsDenseListMetricsRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    backgroundColor: ticketColors.tile,
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: spacing.sm,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.rule,
  },
  reportsDenseListRowBorder: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    paddingTop: spacing.sm,
    marginTop: spacing.sm,
  },
  reportsDenseListMetricGutter: {
    width: 1,
    alignSelf: 'stretch',
    backgroundColor: ticketColors.rule,
    marginHorizontal: 4,
  },
  reportsDenseListMetricCell: {
    flex: 1,
    minWidth: 0,
    alignItems: 'flex-start',
  },
  reportsDenseListMetricsMoneyWrap: {
    flex: 1.2,
    minWidth: 0,
    alignItems: 'flex-end',
  },
  reportsDenseListMetricValue: {
    color: ticketColors.ink,
    fontSize: 13,
    fontWeight: '600',
    fontVariant: ['tabular-nums'],
  },
  reportsDenseListMetricLabel: {
    marginTop: 1,
    color: ticketColors.ink3,
    fontSize: 10,
    lineHeight: 13,
    letterSpacing: 0.2,
  },
  reportsDenseListMoney: {
    color: ticketColors.ink,
    fontSize: 16,
    fontWeight: '700',
    fontVariant: ['tabular-nums'],
    letterSpacing: 0.2,
  },
  reportsDenseListFieldRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
    marginBottom: 3,
    paddingVertical: 0,
  },
  reportsDenseListFieldLabel: {
    color: ticketColors.ink3,
    fontSize: 12,
    flexShrink: 0,
    width: 118,
  },
  reportsDenseListFieldValue: {
    color: ticketColors.ink2,
    fontSize: 12,
    flex: 1,
    textAlign: 'right',
  },
  /** Subrejilla bajo la banda principal (p. ej. operador: ticket, margen, etc.). */
  reportsDenseListStatGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    marginTop: spacing.sm,
  },
  reportsOperacionStatGridWide: {
    flexWrap: 'nowrap',
  },
  reportsOperacionStatItemWide: {
    flexBasis: '30%',
    minWidth: 160,
  },
  reportsOperacionCardsRowWide: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.md,
    alignItems: 'flex-start',
  },
  reportsOperacionCardWide: {
    flex: 1,
    minWidth: 300,
  },
  reportsOperacionWideRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  reportsOperacionRail: {
    width: 168,
    marginRight: spacing.md,
    paddingVertical: spacing.sm,
    gap: 2,
    alignSelf: 'stretch',
  },
  reportsOperacionRailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.xs,
    paddingVertical: 8,
    paddingHorizontal: spacing.sm,
    borderRadius: 8,
  },
  reportsOperacionRailItemText: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '600',
    flexShrink: 1,
  },
  reportsOperacionRailBadge: {
    minWidth: 20,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 10,
    backgroundColor: ticketColors.warnBg,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.warnBorder,
    alignItems: 'center',
  },
  reportsOperacionRailBadgeText: {
    ...typography.caption,
    color: ticketColors.warn,
    fontWeight: '800',
    fontSize: 11,
  },
  reportsDenseListStatItem: {
    flexGrow: 1,
    flexBasis: '47%',
    minWidth: 128,
    backgroundColor: ticketColors.tile,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.rule,
    borderRadius: 8,
    padding: spacing.sm,
    gap: 4,
  },
  reportsDenseListStatItemFull: {
    flexBasis: '100%',
    minWidth: '100%',
  },
  reportsDenseListStatItemLabel: {
    fontSize: 11,
    fontWeight: '600' as const,
    color: ticketColors.ink3,
  },
  reportsDenseListStatItemValue: {
    fontSize: 14,
    fontWeight: '600' as const,
    color: ticketColors.ink,
  },
  /**
   * Contenedor de sección con el mismo “surface” que las cards densas, **sin** barra lateral.
   * Usar cuando adentro hay muchas `ReportsDenseListCard` (p. ej. listado de productos) para no duplicar acentos.
   */
  reportsDenseSectionShell: {
    ...ticketSurfaces.paperSheet,
    marginBottom: spacing.sm,
  },
  reportsDenseSectionShellBody: {
    padding: spacing.md,
    gap: spacing.md,
  },
  /** Título de sheet dentro de shell o card densa (reemplaza `cardTitle` en informes unificados). */
  reportsDenseBlockTitle: {
    ...typography.titleLg,
    fontSize: 15,
    color: ticketColors.ink,
    fontWeight: '800' as const,
  },
  /** Sub-bloque dentro de una sheet (proto `.block-title`): small caps ink3, no compite con el título de la sheet. */
  reportsSheetBlockTitle: {
    fontSize: 11,
    fontWeight: '800' as const,
    color: ticketColors.ink3,
    letterSpacing: 0.8,
    textTransform: 'uppercase' as const,
  },
  reportsDenseListSection: {
    gap: spacing.xs,
    marginTop: spacing.sm,
    paddingTop: spacing.sm,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  /** Modal alineado a la card densa: ancho, sombra implícita del borde. */
  /** Contenedor del panel en modales de informes: el hijo debe ocupar todo el ancho (evita columna 1ch en web). */
  reportsModalDensePressable: {
    width: '100%' as const,
    maxWidth: 520,
    maxHeight: '96%' as const,
    alignSelf: 'center' as const,
    alignItems: 'stretch' as const,
  },
  reportsModalSheetCard: {
    width: '100%' as const,
    maxHeight: '96%' as const,
    alignSelf: 'flex-end' as const,
  },
  reportsModalGrabber: {
    width: 36,
    height: 4,
    borderRadius: 2,
    backgroundColor: ticketColors.rule,
    alignSelf: 'center',
    marginBottom: spacing.xs,
  },
  /** Contenido alineado con pestañas fijas: scroll solo debajo. */
  reportsContentScroll: {
    flex: 1,
    backgroundColor: ticketColors.bg,
  },
  /** Estados sin datos: padding como `content` sin repetir título (el header global ya dice Informes). */
  reportsStateContent: {
    flex: 1,
    padding: spacing.lg,
    paddingBottom: spacing.xxl,
  },
  healthCard: {
    borderLeftWidth: 4,
  },
  healthBadgeWrap: {
    alignSelf: 'flex-start',
  },
  healthBadge: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    borderRadius: 999,
    maxWidth: '100%',
  },
  healthBadgeText: {
    ...typography.caption,
    color: ticketColors.goldInk,
    fontWeight: '700',
  },
  buttonRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  secondaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    backgroundColor: ticketColors.paper2,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    minWidth: 0,
  },
  secondaryButtonText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '600',
    flexShrink: 1,
  },
  cardHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: spacing.md,
    marginBottom: spacing.xs,
  },
  linkText: {
    ...typography.body,
    color: ticketColors.ink2,
    fontWeight: '700',
    flexShrink: 0,
  },
  historyItem: {
    borderBottomWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingVertical: spacing.md,
    gap: spacing.xs,
  },
  historyDate: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  resilienceList: {
    gap: spacing.xs,
  },
  resilienceToggle: {
    alignSelf: 'flex-start',
    marginTop: spacing.xs,
  },
  detailItem: {
    borderBottomWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingVertical: spacing.sm,
    gap: 2,
  },
  detailItemTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  failedError: {
    ...typography.caption,
    color: ticketColors.bad,
    fontSize: 11,
    lineHeight: 14,
  },
  exportButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.lg,
    backgroundColor: ticketColors.paper2,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  exportButtonText: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  /** Sin padding: combinar con `useModalBackdropPadding()` en cada Modal. */
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.6)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalCard: {
    width: '100%',
    maxHeight: '88%',
    backgroundColor: ticketColors.paper,
    borderRadius: 16,
    padding: spacing.lg,
    gap: spacing.sm,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
  },
  qrWrap: {
    alignItems: 'center',
    paddingVertical: spacing.lg,
  },
  salesSearchInput: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    backgroundColor: ticketColors.paper,
    color: ticketColors.ink,
    marginBottom: spacing.sm,
  },
  /** Listado Ventas (móvil): menos alto vertical. */
  salesSearchInputCompact: {
    paddingVertical: spacing.xs + 2,
    marginBottom: spacing.xs,
    minHeight: 40,
  },
  /** Junto a chips de orden en layout ancho: barra no a todo el ancho. */
  salesSearchInputInline: {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 160,
    maxWidth: 420,
    paddingVertical: spacing.xs + 2,
    marginBottom: 0,
    minHeight: 40,
  },
  salesListRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
    gap: spacing.sm,
  },
  salesListRowLeft: {
    flex: 1,
    minWidth: 0,
    gap: 4,
  },
  salesListRowProducts: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '500',
  },
  salesListRowRef: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontSize: 11,
  },
  salesModalScroll: {
    maxHeight: 420,
  },
  saleDetailSummaryBlock: {
    gap: spacing.xs,
    paddingBottom: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
  },
  saleStatusBadge: {
    borderRadius: 999,
    borderWidth: 1,
    paddingHorizontal: spacing.sm,
    paddingVertical: 2,
    alignSelf: 'flex-start',
  },
  saleStatusBadgeActive: {
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
  },
  saleStatusBadgeVoided: {
    borderColor: ticketColors.bad,
    backgroundColor: 'rgba(248, 113, 113, 0.12)',
  },
  saleStatusBadgeText: {
    ...typography.caption,
    fontWeight: '700',
  },
  saleStatusBadgeTextActive: {
    color: ticketColors.ink2,
  },
  saleStatusBadgeTextVoided: {
    color: ticketColors.bad,
  },
  voidReasonBlock: {
    marginTop: spacing.xs,
    gap: spacing.xs,
  },
  voidReasonText: {
    ...typography.body,
    color: ticketColors.ink,
  },
  voidSaleButton: {
    marginTop: spacing.lg,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.bad,
    backgroundColor: 'rgba(248, 113, 113, 0.12)',
    paddingVertical: spacing.md,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
  },
  voidSaleButtonText: {
    ...typography.body,
    color: ticketColors.bad,
    fontWeight: '700',
  },
  saleDetailSection: {
    gap: spacing.sm,
    marginTop: spacing.md,
  },
  saleDetailItemRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing.md,
    paddingVertical: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
  },
  saleDetailItemName: {
    ...typography.body,
    color: ticketColors.ink,
    flex: 1,
    fontWeight: '600',
    minWidth: 0,
  },
  saleDetailItemAmount: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
    flexShrink: 0,
  },
  saleDetailItemCode: {
    ...typography.caption,
    color: ticketColors.ink3,
    marginTop: 4,
  },
  saleDetailPaymentRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing.md,
    paddingVertical: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
  },
  saleDetailPaymentLeft: {
    flex: 1,
    minWidth: 0,
  },
  saleDetailPaymentStatus: {
    ...typography.caption,
    color: ticketColors.ink2,
    marginTop: 2,
  },
  /** Informes > Personal: carrusel de filtro por operador */
  personalFilterScroll: {
    marginBottom: spacing.sm,
  },
  personalFilterScrollContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: spacing.xs,
  },
  personalOperatorBlock: {
    backgroundColor: ticketColors.paper,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    padding: spacing.md,
    marginBottom: spacing.md,
    gap: spacing.sm,
  },
  personalRankHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  personalRankBadge: {
    minWidth: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: spacing.xs,
  },
  personalRankBadgeText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
    fontSize: 12,
  },
  personalOperatorName: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
    flex: 1,
    minWidth: 0,
  },
  personalOperatorTotal: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontWeight: '800',
    flexShrink: 0,
    marginLeft: spacing.xs,
  },
  personalStatGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  personalStatItem: {
    flexGrow: 1,
    flexBasis: '47%',
    minWidth: 128,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    padding: spacing.sm,
    gap: 4,
  },
  personalStatItemLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
    fontSize: 11,
  },
  personalStatItemValue: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  personalStatItemFull: {
    flexBasis: '100%',
    minWidth: '100%',
  },
  /** Misma idea que Catálogo: control tipo «select» + bottom sheet (no chips). */
  reportsSalesListPickerRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    marginBottom: spacing.sm,
    alignSelf: 'stretch',
  },
  reportsSalesListPickerRowWide: {
    marginBottom: 0,
    gap: spacing.md,
  },
  reportsSalesListPicker: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '47%',
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  /** Móvil / tablet angosto: 2 columnas, etiqueta arriba del valor. */
  reportsSalesListPickerMobile: {
    flexBasis: '47%',
    minWidth: 0,
    minHeight: 52,
    paddingVertical: 9,
  },
  reportsSalesListPickerActive: {
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.brandSoft,
  },
  reportsSalesListPickerDisabled: {
    opacity: 0.55,
  },
  reportsSalesListPickerInner: {
    flex: 1,
    minWidth: 0,
    gap: 1,
  },
  /** Misma línea visual que buscador unificado (Informes Ventas · desktop). */
  reportsSalesListPickerWideInline: {
    minHeight: 44,
    paddingVertical: 9,
    borderRadius: 10,
    alignSelf: 'stretch',
  },
  /** Escritorio: rejilla flexible (Tipo, Categoría, Marca, Proveedor, Operador, Cliente). */
  reportsSalesListPickerWideGrid: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minWidth: 148,
    maxWidth: 240,
  },
  reportsSalesListPickerInnerInline: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  reportsSalesListPickerCaption: {
    ...typography.caption,
    fontSize: 10,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.35,
  },
  reportsSalesListPickerValue: {
    ...typography.body,
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '800',
    color: ticketColors.ink,
  },
  reportsScopeEntityFilterValueMuted: {
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  reportsSalesListModalBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'flex-end',
  },
  reportsSalesListModalBackdropWeb: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing.md,
  },
  reportsSalesListModalSheet: {
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 18,
    borderTopRightRadius: 18,
    paddingHorizontal: spacing.md,
    paddingTop: spacing.md,
    maxHeight: '78%',
    borderTopWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  reportsSalesListModalSheetWeb: {
    width: '100%',
    maxWidth: 484,
    maxHeight: '88%',
    alignSelf: 'center',
    borderBottomLeftRadius: 14,
    borderBottomRightRadius: 14,
  },
  reportsSalesListModalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing.sm,
  },
  reportsSalesListModalTitle: {
    ...typography.body,
    fontSize: 17,
    fontWeight: '800',
    color: ticketColors.ink,
  },
  reportsSalesListModalScroll: {
    maxHeight: 420,
  },
  reportsSalesListSheetRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingVertical: 12,
    paddingHorizontal: 4,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  reportsSalesListSheetRowSelected: {
    backgroundColor: ticketColors.brandSoft,
    marginHorizontal: -4,
    paddingHorizontal: 8,
    borderRadius: 10,
    borderBottomWidth: 0,
  },
  reportsSalesListSheetRowText: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  reportsSalesListSheetRowTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  reportsSalesListSheetRowTitleSelected: {
    color: ticketColors.ink,
  },
  reportsSalesListSheetRowSubtitle: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '600',
  },
});
